import type { MouseEvent } from 'react'
import { useCallback, useContext, useRef } from 'react'
import ModalContext from 'contexts/ModalContext'
import RecentChatItemActionsSheet from './RecentChatItemActionsSheet'

interface UseOpenRecentChatItemActionsSheetArgs {
  title: string
  onRename: (name: string) => Promise<void>
  onDelete: () => void
  onDownloadPdf?: () => void
  onDownloadSpreadsheet?: () => void
}
export default function useOpenRecentChatItemActionsSheet({
  title,
  onRename,
  onDelete,
  onDownloadPdf,
  onDownloadSpreadsheet,
}: UseOpenRecentChatItemActionsSheetArgs) {
  const showModal = useContext(ModalContext)
  const closeSheetRef = useRef<(() => void) | undefined>(undefined)

  const handleClose = useCallback(() => {
    closeSheetRef.current?.()
  }, [])

  const handleDelete = useCallback(() => {
    closeSheetRef.current?.()
    onDelete()
  }, [onDelete])

  return useCallback((event: MouseEvent) => {
    event.preventDefault()
    event.stopPropagation()

    showModal<void>((resolve) => {
      closeSheetRef.current = () => resolve()

      return (
        <RecentChatItemActionsSheet
          title={title}
          onClose={handleClose}
          onRename={onRename}
          onDelete={handleDelete}
          onDownloadPdf={onDownloadPdf}
          onDownloadSpreadsheet={onDownloadSpreadsheet}
        />
      )
    })
  }, [handleClose, handleDelete, onDownloadPdf, onDownloadSpreadsheet, onRename, showModal, title])
}
